import "regenerator-runtime/runtime";

import React from 'react';
import ReactDOM from 'react-dom';
import coreBlocks, { Registry as BlockRegistry } from '@sightworks/block';
import { Blocks as AlertBlocks } from '@sightworks/alert';
import { ThemeProvider } from '@material-ui/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from './theme';
import CustomBlock from './blocks/custom-block/browser';
import { preload } from '@sightworks/theme';
import NamedStyles from '../styles/browser';
import NamedThemes from '../themes/browser';
import { Blocks as FormBlocks } from '@sightworks/form';

BlockRegistry.addNamedStyles(NamedStyles);
BlockRegistry.addNamedThemes(NamedThemes);
BlockRegistry.addBlocks(coreBlocks);
BlockRegistry.addBlocks(AlertBlocks);
BlockRegistry.addBlocks(FormBlocks);
BlockRegistry.addBlocks({ 'custom-block': CustomBlock });
BlockRegistry.setTheme(theme);

function Main({ rootProps }) {
	React.useEffect(() => {
		const jssStyles = document.querySelector('#jss-server-side');
		if (jssStyles) {
			jssStyles.parentNode.removeChild(jssStyles);
		}
	}, []);

	const Page = coreBlocks.page;
	return <Page.component {...rootProps}/>;
}

export async function run(path) {
	window.addEventListener('popstate', event => {
		if (event.state) {
			update(event.state.path, event.state, false);
		}
	});

	let rootProps = history.state;
	let hydrate = false;
	let doFetch = async () => {};
	
	if (true || !rootProps || !rootProps.props) {
		let req = await fetch(path);
		rootProps = await req.json();
		hydrate = true;
	} else {
		let rp = (rootProps || {path: location.href}).path;
		doFetch = async () => {
			let req = await fetch(path);
			let rootProps = await req.json();
			if (rp == location.href) {
				rootProps.path = rp;
				if (history.replaceState)
					history.replaceState(rootProps, rootProps.title, rootProps.path);
				await preload(rootProps.props);
				document.querySelector('title').textContent = rootProps.title;
				document.querySelector('meta[name=description]').content = rootProps.description;
				document.querySelector('meta[name=keywords]').content = rootProps.keywords;
				ReactDOM.render(<Main rootProps={rootProps.props}/>, document.querySelector('#root'));
			}
		}
	}
	// let rootProps = JSON.parse(document.querySelector('#rootProps').textContent);
	await preload(rootProps.props);
	if (!rootProps.path) {
		rootProps.path = location.href;
	}
	if (history.replaceState)
		history.replaceState(rootProps, rootProps.title, rootProps.path);
	if (hydrate)
		ReactDOM.hydrate(<Main rootProps={rootProps.props}/>, document.querySelector('#root'));
	else {
		document.querySelector('#root').innerHTML = "";
		document.querySelector('title').textContent = rootProps.title;
		document.querySelector('meta[name=description]').content = rootProps.description;
		document.querySelector('meta[name=keywords]').content = rootProps.keywords;
		ReactDOM.render(<Main rootProps={rootProps.props}/>, document.querySelector('#root'));
	}

	await doFetch();
}

export async function update(path, props, pushState = true) {
	if (history.pushState) {
		let baseHref = document.querySelector('base').href;
		if (path.startsWith(baseHref)) {
			let suffix = path.substring(baseHref.length);
			let rootProps = props;
			if (!props) {
				let req = await fetch(baseHref + 'json/' + suffix);
				rootProps = await req.json();
			}
			await preload(rootProps.props);
			rootProps.path = path;
			document.querySelector('title').textContent = rootProps.title;
			document.querySelector('meta[name=description]').content = rootProps.description;
			document.querySelector('meta[name=keywords]').content = rootProps.keywords;
			ReactDOM.render(<Main rootProps={rootProps.props}/>, document.querySelector('#root'));
			if (pushState) {
				history.pushState(rootProps, rootProps.title, path);
			}
		}
	}
}

BlockRegistry.setUpdater(update);

export default __webpack_require__;

